module.exports = __webpack_public_path__ + "static/media/search-icon-btn.dbe9ff1e.svg";